import axios from "axios";
import jwt_decode from "jwt-decode";
import * as routerHelpers from "../../../router/RouterHelpers";
import * as auth from "../../../store/ducks/auth.duck";
import { notificationEmitter } from "../../../utils/notificationEmitter";

const interceptor = axios.create();

interceptor.interceptors.request.use(
  (config) => {
    let data = {};
    const json = require("../../../../config.json");
    const urlBase = json.urlBase;
    const dateTime = Date.now();
    const timestamp = Math.floor(dateTime / 1000);
    const stored = JSON.parse(localStorage.getItem("persist:demo4-auth"));
    if (!stored || !stored.authToken) {
      window.location.href = "/auth/login";
      return Promise.reject(new Error("No auth token"));
    }
    let token = stored.authToken.replace(/['"]+/g, "");
    let jwt = jwt_decode(token);
    config.headers.Authorization = token;
    if (
      timestamp > (jwt.exp - jwt.iat) * 0.8 + jwt.iat &&
      timestamp <= jwt.exp
    ) {
      // alert("mas");
      axios
        .get(urlBase + "/auth/refresh")
        .then(({ data: { result } }) => {
          // console.log(result);
          data = {
            authToken: result.access_token,
            user: result.first_name,
            _persist: `{"version":-1,"rehydrated":true}`,
          };

          window.localStorage.setItem(
            "persist:demo4-auth",
            JSON.stringify(data)
          );

          try {
            const storedDetails =
              JSON.parse(window.localStorage.getItem("userDetails")) || {};
            if (Object.keys(storedDetails).length > 0) {
              const updatedDetails = {
                ...storedDetails,
                access_token: result.access_token,
              };
              window.localStorage.setItem(
                "userDetails",
                JSON.stringify(updatedDetails)
              );
            }
          } catch (storageError) {
            console.warn("Unable to refresh stored user details:", storageError);
          }
        })
        .catch((error) => {
          // console.log(error);
          window.location.href = "/logout";
        });
    } else if (timestamp > jwt.exp) {
      window.location.href = "/logout";
    } else {
      // alert("menos");
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
interceptor.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Handle 401 Unauthorized errors (token expired)
    if (error.response && error.response.status === 401) {
      // Clear localStorage
      localStorage.removeItem("persist:demo4-auth");
      localStorage.removeItem("userDetails");

      // Redirect to login page
      window.location.href = "/auth/login";

      return Promise.reject(error);
    }

    // Handle 403 Forbidden errors (insufficient permissions)
    if (error.response && error.response.status === 403) {
      // Show notification with the error message from the API
      const message = error.response.data?.message || 'You do not have permission to perform this action';
      notificationEmitter.showError('Access Denied', message);

      return Promise.reject(error);
    }

    // Do something with response error
    return Promise.reject(error);
  }
);

export default interceptor;
